<template>
  <div class="titleBox flex-row ite-c"
        :style="{
          'background':backgroundColor+ '!important'
        }"
  >
    <b>{{topTitle.title}}</b><span v-show="topTitle.subTit!==''">-{{topTitle.subTit}}</span>
  </div>
</template>

<script>
    export default {
        name: "titleBox",
        // props: ['topTitle']
        props: {
          topTitle: {
          },
          backgroundColor:{ // 背景颜色
              type:String,
              required:false,
          },
        }
    }
</script>

<style scoped>
  /*  顶部标题  */
  .titleBox{
    width: 100%;
    background: #FBFBFB;
    /* background: #ffffff; */
    height: 44px;
    padding-left: 9px;
    box-sizing: border-box;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
  }
  .titleBox b{
    /* color:#2B2727; */
    /* font-size: 13px; */
    color:#333333;
    font-size: 14px;
    font-size: 15px;
  }
  /* .titleBox b::before{
    content: '';
    display: inline-block;
    height: 19px;
    width: 6px;
    background: #1DB56F;
    margin-right: 10px;
    vertical-align: middle;
  } */
  .titleBox span{
    color:#7F7F7F;
    font-size: 12px;
  }
</style>
